import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Calendar, Form, Layout, message, Row } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
import './style.scss';

import PdButton from 'components/pd-button';
import RentService from 'services/rent';
import { errHandling } from 'utils';

const { Content } = Layout;

export function BlackoutDateCreateEdit() {
  const navigate = useNavigate();
  const [value, setValue] = useState(dayjs(new Date().toISOString()));
  const [selectedValue, setSelectedValue] = useState('');

  const handleSubmit = async (event) => {
    event.persist();
    event.preventDefault();
    if (dayjs(selectedValue).isBefore(dayjs(), 'day')) {
      message.error(`Past date is not allowed`);
    } else {
      try {
        await RentService.setBlackoutDate({
          blackout_date: {
            date: selectedValue.toISOString(),
          },
        });
        message.success('New blackout date is added');
        navigate('/blackout_dates');
      } catch (error) {
        errHandling(error);
      }
    }
  };

  const handleOnChange = (val = '') => {
    if (val === 'panel_change') setValue(dayjs(val));
    else {
      setValue(dayjs(val));
      setSelectedValue(dayjs(val));
    }
  };

  return (
    <Layout className="pd-cms-durations main-container">
      <div className="content">
        <div className="pageTitle">Create New Blackout Date</div>
        <Content>
          <Form onSubmit={handleSubmit}>
            <div className="section-container">
              <div className="inner-section">
                <Row gutter={20}>
                  <Alert
                    message={`Blackout Date: ${
                      selectedValue
                        ? selectedValue.format('DD-MM-YYYY')
                        : 'Please select a date'
                    }`}
                  />
                  <Calendar
                    defaultValue={value}
                    onSelect={handleOnChange}
                    onPanelChange={handleOnChange.bind(this, 'panel_change')}
                  />
                </Row>
              </div>
            </div>

            <div className="section-container">
              <Form.Item>
                <div className="buttonSection">
                  <PdButton htmlType="submit" type="primary" full>
                    Publish
                  </PdButton>
                </div>
              </Form.Item>
            </div>
          </Form>
        </Content>
      </div>
    </Layout>
  );
}

export default { BlackoutDateCreateEdit };
